module.exports = __webpack_public_path__ + "media/src/images/icons/arrow-right-white-d5e8b4577399a0ec39b4b5b295364d18.svg";